import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/index.css'
import { suppressWebGLWarnings } from './utils/suppressWebGLWarnings'

// Suppress WebGL warnings that don't affect functionality
suppressWebGLWarnings()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
